export default [
  {
    title: 'Dashboard',
    route: 'area-clienti-dashboard',
    icon: 'HomeIcon',
    action: 'customer',
    resource: 'ACL',
  },
  {
    title: 'Profilo ',
    route: 'area-clienti-profilo',
    icon: 'UserIcon',
    action: 'customer',
    resource: 'ACL',
  },
  {
    title: 'Licenze ',
    route: 'area-clienti-licenze',
    icon: 'AwardIcon',
    action: 'customer',
    resource: 'ACL',
  },
  {
    title: 'Fatture ',
    route: 'area-clienti-fatture',
    icon: 'FileTextIcon',
    action: 'customer',
    resource: 'ACL',
  },
]
